import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import ResourceCard from '../resource-card/resource-card.vue';
import ContactCard from '../contact-card/contact-card.vue';
import ActivityCard from '../activity-card/activity-card.vue';
import PublicPostCard from '../public-post-card/public-post-card.vue';
import PublicResourceCard from '../public-resource-card/public-resource-card.vue';
import PublicDisciplineCard from '../public-discipline-card/public-discipline-card.vue';
import PublicActivityCard from '../public-activity-card/public-activity-card.vue';
import PublicContactCard from '../public-contact-card/public-contact-card.vue';
import SubscriptionCategoryCard from '@shared/components/cards/subscription-category-card/subscription-category-card.vue';
import ArticleCard from '@shared/components/cards/article-card/article-card.vue';
import MediaCard from '@shared/components/cards/media-card/media-card.vue';
import PublicSubscriptionCategoryCard
  from "@shared/components/cards/public-subscription-category-card/public-subscription-category-card.vue";

@Component({
  name: 'bpc-entity-card-item',
  components: {
    'bpc-resource-card': ResourceCard,
    'bpc-contact-card': ContactCard,
    'bpc-activity-card': ActivityCard,
    'bpc-public-post-card': PublicPostCard,
    'bpc-public-resource-card': PublicResourceCard,
    'bpc-public-discipline-card': PublicDisciplineCard,
    'bpc-public-activity-card': PublicActivityCard,
    'bpc-public-contact-card': PublicContactCard,
    'bpc-subscription-category-card': SubscriptionCategoryCard,
    'bpc-public-subscription-category-card': PublicSubscriptionCategoryCard,
    'bpc-article-card': ArticleCard,
    'bpc-media-card': MediaCard,
  },
})
export default class EntityCardItem extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  @Prop(Object) readonly item: AnyEntity;
  @Prop(String) readonly entity: string;
  @Prop(String) readonly type: string;
  @Prop(String) readonly component: string;

  get componentName(): string {
    if (this.component) {
      return this.component;
    }

    switch (this.entity) {
      case 'resource':
        return `bpc-${this.type ? this.type + '-' : ''}resource-card`;
      case 'discipline':
        return `bpc-${this.type ? this.type + '-' : ''}discipline-card`;
      case 'bpc-activity':
        return `bpc-${this.type ? this.type + '-' : ''}activity-card`;
      case 'contact':
        return `bpc-${this.type ? this.type + '-' : ''}contact-card`;
      case 'post':
        return `bpc-${this.type ? this.type + '-' : ''}post-card`;
      case 'subscription-category':
        return `bpc-${this.type ? this.type + '-' : ''}subscription-category-card`;
      case 'article':
        return `bpc-${this.type ? this.type + '-' : ''}article-card`;
      case 'media':
        return `bpc-${this.type ? this.type + '-' : ''}media-card`;
      default:
        return 'bpc-generic-card';
    }
  }

  onActionClicked(event, item) {
    this.$emit('action-clicked', event, item);
  }
}
